import { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined';
import axios from 'axios';

const BFF_API_URL = import.meta.env.VITE_BFF_API_URL || 'http://localhost:8086';

const DEFAULT_MESSAGE =
  'DEMO ENVIRONMENT — This is a demonstration system. Some features, data, payments, and integrations may be limited or behave differently from the production environment.';

function getAuthToken(): string | null {
  const cookies = document.cookie.split(';');
  for (const cookie of cookies) {
    const [name, value] = cookie.trim().split('=');
    if (name === 'session_token') return value;
  }
  return null;
}

export default function DemoBanner() {
  const [visible, setVisible] = useState(false);
  const [message, setMessage] = useState(DEFAULT_MESSAGE);

  useEffect(() => {
    const token = getAuthToken();
    if (!token) return;

    axios
      .get(`${BFF_API_URL}/api/v1/config`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(res => {
        const configs = res.data?.configs || [];
        const demoFlag = configs.find((c: any) => c.key === 'system.demo_mode');
        const demoMsg = configs.find((c: any) => c.key === 'system.demo_message');
        if (demoFlag && String(demoFlag.value) === 'true') {
          setVisible(true);
          if (demoMsg?.value) setMessage(String(demoMsg.value));
        }
      })
      .catch(() => {});
  }, []);

  if (!visible) return null;

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 80,
        left: 24,
        zIndex: 2000,
        maxWidth: 420,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'flex-start',
          gap: 1.5,
          px: 2.5,
          py: 1.75,
          bgcolor: '#1B1F1C',
          borderLeft: '3px solid #F9A825',
          boxShadow: '0 4px 24px rgba(0,0,0,0.18)',
        }}
      >
        <WarningAmberOutlinedIcon
          sx={{ fontSize: 16, color: '#F9A825', mt: 0.15, flexShrink: 0 }}
        />
        <Typography
          sx={{
            fontFamily: '"Space Mono", monospace',
            fontSize: '0.68rem',
            color: 'rgba(250,250,248,0.85)',
            letterSpacing: '0.02em',
            lineHeight: 1.5,
          }}
        >
          {message}
        </Typography>
      </Box>
    </Box>
  );
}
